import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ForecastRepository from "../../../repository/ForecastRepository";
import { __remove, __set } from "../../axios_indicator";

export const getForecastData = createAsyncThunk('forecast_getForeCastData', async (params) => {
    __set('FORECAST_API_CALL');
    return await new ForecastRepository().getForecastData(params)
});

export const setOpenAccordionList = createAsyncThunk('forecast_setOpenAccordionList', async (id) => {
    return id
});

export const forecastShare = createAsyncThunk('forecast_forecastShare', async (params) => {
    __set('SHARE_FORECAST_API_CALL');
    return await new ForecastRepository().forecastShare(params.sendToEmails, params.subject, params.message, params.filterOption);
});

const initialState = {
    forecastList: {},
    forecastCounts: {},
    lastForecastReceivedDate: '',
    forecastDetailList: {},
    forecastDateColumns: [],
    openAccordionList: []
};
const slice = createSlice({
    name: "Forecast",
    initialState: initialState,
    reducers: {
    },
    extraReducers: {
        [getForecastData.fulfilled]: (state, { payload }) => {
            if (payload) {
                let forecastRes = payload.data
                if (forecastRes.forecastCounts) {
                    state.forecastCounts = forecastRes.forecastCounts;
                }
                if (forecastRes.lastForecastReceivedDate) {
                    state.lastForecastReceivedDate = forecastRes.lastForecastReceivedDate;
                }
                if (forecastRes.forecastList) {
                    state.forecastList = forecastRes.forecastList;
                }
                if (forecastRes.forecastDetailList) {
                    state.forecastDetailList = forecastRes.forecastDetailList;
                }

                if (forecastRes.forecastDateColumns) {
                    state.forecastDateColumns = forecastRes.forecastDateColumns;
                }
            } else {
                state.lastForecastReceivedDate = ''
                state.forecastList = {}
            }

            setTimeout(() => {
                __remove('FORECAST_API_CALL');
            }, 200);
            return state;
        },
        [getForecastData.rejected]: (state, { payload }) => {
            setTimeout(() => {
                __remove('FORECAST_API_CALL');
            }, 200);
        },
        [setOpenAccordionList.fulfilled]: (state, { payload }) => {
            let list = [...state.openAccordionList]

            list.indexOf(payload) === -1
                ? list.push(payload)
                : list.splice(list.indexOf(payload), 1)

            state.openAccordionList = list
            return state;
        },
        [setOpenAccordionList.rejected]: (state, { payload }) => {
        },
        [forecastShare.fulfilled]: (state, { payload }) => {
            __remove('SHARE_FORECAST_API_CALL');
        },
        [forecastShare.rejected]: (state, { payload }) => {
            __remove('SHARE_FORECAST_API_CALL');
        }
    },
});

export let { } = slice.actions;

export default slice.reducer;
